import { useEffect, useState, useRef } from "react";
import { User, Mail, Phone, Edit, LockIcon, LockKeyhole, Info, X, Search } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import { createuser, getUserlist, importcustomer, SendPasswordAPI } from "../../services/api";
import Pagination from "../../hooks/Pagination";
import ShimmerLoader from "../../hooks/ShimmerLoader";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
export default function Customer() {
  useDocumentTitle('Welcome to Admin | Customer');

  const targetRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [userrlist, setUserlist] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    UserType: "0",
    title: "",
    name: "",
    fname: "",
    lname: "",
    email: "",
    mobile: "",
    address: "",
  });
  const handleScroll = () => {
    targetRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const [fileData, setFileData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showForm, setShowForm] = useState(false); // registration form hidden by default
  const perPage = 20;
  const fetchusers = async (perPage, currentPage, search = debouncedSearch) => {
    try {
      const response = await getUserlist(perPage, currentPage, search || null); // 3rd arg = keyword (null when empty)
      const data = await response.data;
      setUserlist(data.data || data);
      setCurrentPage(data.current_page);
      setTotalPages(data.last_page);
    } catch (err) {
      setError(err.message || 'Failed to fetch Loyalty Card');
    } finally {
      setLoading(false);
    }
  };
  // Debounce the search input and jump back to page 1 on a new search
  useEffect(() => {
    const timer = setTimeout(() => {
      const term = searchTerm.trim();
      if (term !== debouncedSearch) {
        setDebouncedSearch(term);
        setCurrentPage(1);
      }
    }, 400);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    fetchusers(perPage, currentPage, debouncedSearch);
  }, [currentPage, debouncedSearch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleViewLocation = (item) => {
    const fullName = `${item?.fname || ''} ${item?.lname || ''}`.trim() || 'Customer';
    const url = `/web/home?id=${item?.id ?? ''}&name=${encodeURIComponent(fullName)}&mobile=${encodeURIComponent(item?.mobile ?? '')}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleEdit = ((item) => {
    setShowForm(true)
    setEditMode(true)
    setFormData(item)
    // wait for the form to render before scrolling to it
    setTimeout(() => targetRef.current?.scrollIntoView({ behavior: 'smooth' }), 0);
  })
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      if (formData.UserType === undefined || formData.UserType === null || formData.UserType === "") {
        toastr.error("Please Enter User Type");
        return false;
      }


      if (formData.UserType == '2') {
        if (!formData.agencyName || formData.agencyName == "") {
          toastr.error("Please Enter Agency Name")
          return false
        }
      }
      if (!formData.fname || formData.fname == "") {
        toastr.error("Please Enter First Name")
        return false
      }
      if (!formData.lname || formData.lname == "") {
        toastr.error("Please Enter Last Name")
        return false
      }

      if (!formData.title || formData.title == "") {
        toastr.error("Please Select Salutation")
        return false
      }

      if (!formData.email || formData.email == "") {
        toastr.error("Please Enter Email")
        return false
      }

      if (!formData.mobile || formData.mobile == "") {
        toastr.error("Please Enter Contact Number")
        return false
      }

      if (formData.mobile && formData.mobile.length < 10) {
        toastr.error("Contact Number Should be Minimum of 10 Digits")
        return false
      }

      // const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      // const numbers = Array.from({ length: 1000 }, (_, i) => i + 1);
      // const results = [];

      // for (const number of numbers) {
      //   const randomDigits = Math.floor(Math.random() * 10000000000).toString().padStart(10, '0');
      //   let dumpdata = {
      //     "UserType": "0",
      //     "title": "Mr",
      //     "name": "",
      //     "fname": "Test "+ number,
      //     "lname": "Customer",
      //     "email": "test_user_"+number+"@gmail.com",
      //     "mobile": randomDigits,
      //     "address": ""
      //   }
      //   const response = await createuser(dumpdata);
      //   console.log(dumpdata);
      //   console.log(response);
      //   await sleep(1000); // 1 second delay between calls
      // }
      // console.log(formData);
      // return false;

      const response = await createuser(formData);
      toastr.options = {
        closeButton: true,
        progressBar: true,
        timeOut: 3000,
        positionClass: 'toast-top-right'
      };
      if (response.status.success) {
        toastr.success(response.message)
        setFormData("")
      } else {
        toastr.error(response.message)
      }

      fetchusers(perPage, currentPage, debouncedSearch);

    } catch (error) {
      console.error("Error:", error);
      alert("Registration failed. Please try again.");
    }
  };
  const handleCloseForm = () => {
    setShowForm(false)
    setEditMode(false)
    setFormData({
      UserType: "0",
      title: "",
      name: "",
      fname: "",
      lname: "",
      email: "",
      mobile: "",
      address: "",
    })
  }
  const handleresetform = () => {
    setEditMode(false)
    setFormData("")
  }
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const fileExtension = file.name.split('.').pop().toLowerCase();

    // Handle CSV file
    if (fileExtension === 'csv') {
      Papa.parse(file, {
        complete: (result) => {
          // console.log('CSV Data:', result.data); // Logs the parsed CSV data
          setFileData(result.data); // Set only the data without CSV metadata
        },
        header: true, // Assuming the first row contains headers
        skipEmptyLines: true,
      });
    }

    // Handle Excel file parsing
    else if (['xls', 'xlsx'].includes(fileExtension)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        setFileData(jsonData);
      };
      reader.readAsBinaryString(file);
    }

  };
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const demoCSV = `firstname,lastname,UserType,email,mobile
  John,Doe,b2c,john.doe@example.com,234567890
  Jane,Smith,b2b,jane.smith@example.com,987654321`;

  // Function to download the demo CSV file
  const downloadDemoCSV = () => {
    const blob = new Blob([demoCSV], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'demo-file.csv');
      link.click();
    }
  };
  const uploadFileData = async () => {
    if (!fileData) {
      toastr.error('Please upload a valid CSV or Excel file.');
      return;
    }
    const CSVdata = (fileData);
    const importcsv = await importcustomer(CSVdata)
    if (importcsv.status.success) {
      toastr.success(importcsv.message)
      toggleModal()
    } else {
      toastr.success(importcsv.message)
    }
  };
  const SendPassword = async (id) => {
    const CSVdata = (fileData);
    const importcsv = await SendPasswordAPI(id)
    if (importcsv.status.success) {
      toastr.success(importcsv.message)
    } else {
      toastr.success(importcsv.message)
    }
  };
  return (
    <div className="">
      {error && <div style={{ color: 'red' }}>{error}</div>}

      {showForm && (
      <div className="w-full bg-white shadow-lg rounded-2xl p-6 space-y-6" ref={targetRef}>
        <form onSubmit={handleSubmit}>
          <div className="relative">
            <h2 className="text-2xl font-bold text-center">User Registration</h2>
            <button
              type="button"
              onClick={handleCloseForm}
              title="Close"
              aria-label="Close"
              className="absolute right-0 top-1/2 -translate-y-1/2 p-1 rounded-full text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors"
            >
              <X size={22} />
            </button>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 mt-4 mb-4">
            <button
              type="button"
              onClick={toggleModal}
              className="w-full sm:w-auto bg-[#f4a406] text-white py-2 px-4 rounded-xl hover:bg-[#d89005] transition-colors"
            >
              Upload CSV/Excel
            </button>

            {editMode && <button
              type="button"
              onClick={handleresetform}
              className="w-full sm:w-auto bg-[#f4a406] text-white py-2 px-4 rounded-xl hover:bg-[#d89005] transition-colors"
            >
              Add New User
            </button>}
          </div>


          {/* Account Type */}
          <div>
            <label className="block text-sm font-medium mb-2">Account Type</label>
            <div className="flex gap-6">
              {["0", "2"].map((type) => (
                <label key={type} className="inline-flex items-center gap-2">
                  <input
                    type="radio"
                    name="UserType"
                    value={type}
                    checked={formData.UserType == type}
                    onChange={handleChange}
                  // className="accent-[#f4a406]"
                  />
                  <span className="text-sm font-medium">
                    {type === "0" ? "B2C" : "B2B"}
                  </span>
                </label>
              ))}

            </div>
          </div>
          <br></br>

          {/* Name Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Salutation</label>
              <div className="relative">
                <select name="title" value={formData.title || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                >
                  <option value="" disabled>Select</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                  <option value="Dr">Dr</option>
                </select>
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            {formData.UserType == 2 && <div>
              <label className="block text-sm font-medium mb-1">Agency Name</label>
              <div className="relative">
                <input
                  type="text"
                  name="agencyName"
                  value={formData?.agencyName || ""}
                  onChange={handleChange}
                  placeholder="B2B Agency"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>}

            <div>
              <label className="block text-sm font-medium mb-1">First Name</label>
              <div className="relative">
                <input
                  type="text"
                  name="fname"
                  value={formData?.fname || ""}
                  onChange={handleChange}
                  placeholder="John"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Last Name</label>
              <div className="relative">
                <input
                  type="text"
                  name="lname"
                  value={formData?.lname || ""}
                  onChange={handleChange}
                  placeholder="Doe"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Email</label>
              <div className="relative">
                <input
                  readOnly={editMode}
                  type="email"
                  name="email"
                  value={formData?.email || ""}
                  onChange={handleChange}
                  placeholder="you@example.com"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>
          </div>

          <br></br>
          <div>
            <label className="block text-sm font-medium mb-1">Mobile Number</label>
            <div className="flex">
              <select
                name="countrycode"
                value={formData.countrycode || "+91"}
                onChange={handleChange}
                className="h-full rounded-l-xl border border-r-0 pl-3 pr-2 py-2 focus:ring-2 focus:ring-[#f4a406]"
              >
                <option value="91">IN +91</option>
                <option value="971">AE +971</option>
              </select>

              <div className="relative w-full">
                <input
                  type="tel"
                  name="mobile"
                  value={formData?.mobile || ""}
                  onChange={handleChange}
                  placeholder="1234567890"
                  className="w-full pl-10 pr-4 py-2 border rounded-r-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <Phone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>
          </div>



          <br></br>

          {/* Submit */}
          <button
            type="button" onClick={handleSubmit}
            className="w-full bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors"
          >
            {editMode ? "Update User" : "Register User"}
          </button>
        </form>
      </div>
      )}

  <div className="w-full bg-white shadow-lg rounded-2xl p-4 mt-2">
  {/* Header */}
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-2">
    <div>
      <h2 className="text-2xl font-bold text-gray-800">User List</h2>
      <p className="text-sm text-gray-500 mt-1">
        Manage registered users
      </p>
    </div>

    {!showForm && (
      <button
        type="button"
        onClick={() => setShowForm(true)}
        className="inline-flex items-center justify-center bg-[#f4a406] text-white font-medium py-2 px-5 rounded-xl hover:bg-[#d89005] transition-colors shadow-sm"
      >
        Register User
      </button>
    )}
  </div>

  {/* Search */}
  <div className="mb-2">
    <div className="relative w-full sm:max-w-md">
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search name, email or mobile"
        className="w-full pl-10 pr-10 py-2 border border-gray-200 rounded-xl 
                   bg-gray-50 focus:bg-white focus:ring-2 
                   focus:ring-[#f4a406]/30 focus:border-[#f4a406] 
                   focus:outline-none transition"
      />

      <Search
        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        size={18}
      />

      {searchTerm && (
        <button
          type="button"
          onClick={() => setSearchTerm("")}
          title="Clear"
          aria-label="Clear search"
          className="absolute right-2 top-1/2 -translate-y-1/2 
                     p-1.5 rounded-full text-gray-400 
                     hover:text-gray-700 hover:bg-gray-200 transition"
        >
          <X size={16} />
        </button>
      )}
    </div>
  </div>

  {/* Table */}
  <div className="overflow-auto  border border-gray-200 rounded-xl">
    <table className="w-full text-sm text-left">
      <thead className="text-gray-700 bg-gray-100 sticky top-0 z-10">
        <tr>
          <th className="px-4 py-3 font-semibold whitespace-nowrap">
            ID
          </th>
          <th className="px-4 py-3 font-semibold whitespace-nowrap">
            First Name
          </th>
          <th className="px-4 py-3 font-semibold whitespace-nowrap">
            Last Name
          </th>
          <th className="px-4 py-3 font-semibold whitespace-nowrap">
            User Type
          </th>
          <th className="px-4 py-3 font-semibold whitespace-nowrap">
            Email
          </th>
          <th className="px-4 py-3 font-semibold whitespace-nowrap">
            Mobile
          </th>
          <th className="px-4 py-3 font-semibold text-center whitespace-nowrap">
            Actions
          </th>
        </tr>
      </thead>

      <tbody className="divide-y divide-gray-100">
        {loading ? (
          <tr>
            <td className="p-4" colSpan={6}>
              <ShimmerLoader />
              <ShimmerLoader />
              <ShimmerLoader />
            </td>
          </tr>
        ) : userrlist.length > 0 ? (
          userrlist.map((item) => (
            <tr
              key={item.id}
              className="hover:bg-gray-50 transition-colors"
            >
               <td className="px-4 py-3 whitespace-nowrap text-gray-800">
                {item?.id || "-"}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-gray-800">
                {item?.fname || "-"}
              </td>

              <td className="px-4 py-3 whitespace-nowrap text-gray-800">
                {item?.lname || "-"}
              </td>

              <td className="px-4 py-3 whitespace-nowrap">
                <span
                  className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${
                    item?.UserType == "0"
                      ? "bg-blue-50 text-blue-700"
                      : "bg-purple-50 text-purple-700"
                  }`}
                >
                  {item?.UserType == "0" ? "B2C" : "B2B"}
                </span>
              </td>

              <td className="px-4 py-3 text-gray-600">
                {item?.email || "-"}
              </td>

              <td className="px-4 py-3 whitespace-nowrap text-gray-600">
                {item?.mobile || "-"}
              </td>

              <td className="px-4 py-3">
                <div className="flex items-center justify-center gap-2">
                  {/* View Location */}
                  <button
                    type="button"
                    title="View Location"
                    onClick={() => handleViewLocation(item)}
                    className="w-9 h-9 inline-flex items-center justify-center 
                               rounded-lg text-blue-500 bg-blue-50 
                               hover:bg-blue-100 transition"
                  >
                    <Info size={16} />
                  </button>

                  {/* Edit */}
                  <button
                    type="button"
                    title="Edit User"
                    onClick={() => handleEdit(item)}
                    className="w-9 h-9 inline-flex items-center justify-center 
                               rounded-lg text-[#f4a406] bg-amber-50 
                               hover:bg-amber-100 transition"
                  >
                    <Edit size={16} />
                  </button>

                  {/* Send Password */}
                  <button
                    type="button"
                    title="Send Password"
                    onClick={() => SendPassword(item.id)}
                    className="w-9 h-9 inline-flex items-center justify-center 
                               rounded-lg text-red-500 bg-red-50 
                               hover:bg-red-100 transition"
                  >
                    <LockKeyhole size={16} />
                  </button>
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td
              className="px-4 py-12 text-center text-gray-500"
              colSpan={6}
            >
              <div className="flex flex-col items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-3">
                  <Search size={20} className="text-gray-400" />
                </div>

                <p className="font-medium text-gray-600">
                  No users found
                </p>

                <p className="text-sm text-gray-400 mt-1">
                  Try changing your search criteria.
                </p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>

  {/* Pagination */}
  <div className="mt-4">
    <Pagination
      totalPages={totalPages}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
    />
  </div>
</div>

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
            <h3 className="text-xl font-bold mb-4">Upload File (CSV or Excel)</h3>
            <input
              type="file"
              accept=".csv, .xls, .xlsx"
              onChange={handleFileChange}
              className="w-full py-2 px-4 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
            />
            <div className="flex justify-between mt-4">
              <button
                onClick={toggleModal}
                className="bg-gray-400 text-white px-4 py-2 rounded-xl"
              >
                Close
              </button>
              <button
                onClick={uploadFileData}
                className="bg-[#f4a406] text-white px-4 py-2 rounded-xl"
              >
                Upload
              </button>
            </div>
            <div className="mt-4 text-sm">
              <p>Or, download a demo CSV file to see the required format:</p>
              <button
                onClick={downloadDemoCSV}
                className="mt-2 bg-[#f4a406] text-white py-2 px-4 rounded-xl hover:bg-[#d89005] transition-colors"
              >
                Download Demo CSV
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}